module.exports = __webpack_public_path__ + "static/media/paypay-scrn.7ee4b917.jpg";